import { Resources } from './resources';

export class UserResources {
    category: string;
    resources: Resources[] = [];
}
